<template>
    <v-form ref="form" v-model="valid" :disabled="disabled" lazy-validation>
        <!--            workaround-->
        <v-text-field v-show="false" />
        <v-row>
            <v-col
                v-if="
                    pickUpList.length &&
                    (!isProductFieldDisabled('PICK_UP_HOTEL') || !isProductFieldDisabled('PICK_UP_PLACE'))
                "
                cols="12"
                md="4"
            >
                <v-select
                    v-model="point"
                    :label="productFieldLabel('select_pick-up_point', 'PICK_UP_HOTEL')"
                    :items="pickUpList"
                    :rules="hotelRules"
                    item-title="text"
                    item-value="text"
                    hide-details
                    clearable
                    class="mb-2"
                    @update:model-value="changePickUpPoint"
                />
                <div
                    v-if="selectedPickUpPoint && selectedPickUpPoint.latitude && selectedPickUpPoint.longitude"
                    class="text-primary text-decoration-underline text-lowercase cursor-pointer"
                    @click="mapModal = true"
                >
                    <v-icon color="info" start>mdi-map-marker</v-icon>
                    <span v-if="selectedPickUpPoint.address" class="text-grey">{{ selectedPickUpPoint.address }}</span>
                    {{ $t('show_on_map') }}
                </div>
            </v-col>
            <v-col v-if="!isProductFieldDisabled('PICK_UP_TIME')" md="2" cols="12">
                <time-field
                    v-model="time"
                    :label="productFieldLabel('transfers.pickup_time', 'PICK_UP_TIME')"
                    :rules="timeRules"
                    :disabled="!!pickUpList.length && !!startTime"
                    validate-on-blur
                    @change="changeStartTime"
                    @blur="$refs.form.resetValidation()"
                />
            </v-col>
        </v-row>
        <client-only v-if="selectedPickUpPoint && selectedPickUpPoint.latitude && selectedPickUpPoint.longitude">
            <v-dialog v-model="mapModal" :max-width="500">
                <map-location
                    v-if="mapModal"
                    :latitude="selectedPickUpPoint.latitude"
                    :longitude="selectedPickUpPoint.longitude"
                    :height="`500px`"
                />
            </v-dialog>
        </client-only>
    </v-form>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop, VModel} from 'vue-facing-decorator'
    import {ProductBookingFieldsMixin} from '@/components/booking/mixins/ProductBookingFieldsMixin.vue'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'
    import TimeField from '@/components/snippets/forms/TimeField.vue'
    import MapLocation from '@/components/info/MapLocation.vue'

    @Component({
        components: {MapLocation, TimeField},
    })
    export class ActivityBookingForm extends mixins(ProductBookingFieldsMixin, FormValidationRulesMixin) {
        @VModel() valid
        @Prop() info
        @Prop({default: false, type: Boolean}) disabled
        @Prop() offer
        @Prop({type: String}) startTime
        @Prop({default: false, type: Boolean}) disableRequiredRule
        @Prop() pickupLocation

        mapModal = false
        point = null
        time = null

        @Emit()
        change({prop, val}) {
            return {prop, val}
        }

        mounted() {
            if (this.pickUpList?.length) {
                if (!this.isProductFieldDisabled('PICK_UP_HOTEL') || !this.isProductFieldDisabled('PICK_UP_PLACE')) {
                    if (this.pickupLocation) {
                        const pickUpListIndex = this.pickUpList.findIndex(({text}) => text === this.pickupLocation.name)

                        if (pickUpListIndex !== -1) {
                            this.point = this.pickUpList[pickUpListIndex].text
                            this.changePickUpPoint(this.point)
                        }
                    }
                }
                if (!this.isProductFieldDisabled('PICK_UP_TIME')) {
                    this.time = this.selectedPickUpPoint?.startTime
                    this.changeStartTime(this.time)
                }
            } else {
                if (!this.isProductFieldDisabled('PICK_UP_TIME')) {
                    this.time = this.startTime
                }
            }
        }

        changePickUpPoint(val) {
            if (!val) {
                this.change({prop: 'hotelPointKey', val: null})
                this.change({prop: 'pickUpPlace', val: null})
                this.time = null
                this.change({prop: 'startTime', val: null})
                this.$refs.form.validate()
                return
            }
            if (this.selectedPickUpPoint?.hotelPointKey) {
                this.change({prop: 'hotelPointKey', val: this.selectedPickUpPoint.hotelPointKey})
            } else {
                this.change({prop: 'hotelPointKey', val: null})
            }
            if (this.selectedPickUpPoint?.point) {
                this.change({prop: 'pickUpPlace', val: this.selectedPickUpPoint.point})
            } else {
                this.change({prop: 'pickUpPlace', val: null})
            }
            if (!this.isProductFieldDisabled('PICK_UP_TIME')) this.time = this.selectedPickUpPoint.startTime
            this.changeStartTime(this.time)
            this.$refs.form.validate()
        }

        changeStartTime(val) {
            this.change({prop: 'startTime', val: val})
        }

        get selectedPickUpPoint() {
            return this.pickUpList.find(el => el.text === this.point)
        }

        get pickUpList() {
            const list = []
            const getStartTime = pointName => {
                let startTime
                if (this.startTime) {
                    let date = new Date()
                    date = this.$dateFns.setHours(date, this.startTime.split(':')[0])
                    date = this.$dateFns.setMinutes(date, this.startTime.split(':')[1])
                    const index = this.offer?.pickUpPoints?.findIndex(el => el.name === pointName)
                    if (index >= 0 && this.offer.pickUpPoints[index].timeShift) {
                        date = this.$dateFns.add(date, {
                            hours: this.offer.pickUpPoints[index].timeShift.split(':')[0],
                            minutes: this.offer.pickUpPoints[index].timeShift.split(':')[1],
                        })
                    }
                    startTime = this.$dateFns.format(date, 'yyyy-MM-dd HH:mm').split(' ')[1]
                }
                return startTime
            }
            this.info?.departures?.map(departure => {
                if (departure.hotels && !this.isProductFieldDisabled('PICK_UP_HOTEL')) {
                    departure.hotels.map(hotel => {
                        const startTime = getStartTime(hotel.point)
                        list.push({
                            ...hotel,
                            text: hotel.hotelName,
                            startTime,
                        })
                    })
                } else if (!departure.hotels && !this.isProductFieldDisabled('PICK_UP_PLACE')) {
                    const startTime = getStartTime(departure.point)
                    list.push({
                        ...departure,
                        text: departure.point,
                        startTime,
                    })
                }
            })
            return list
        }

        get timeRules() {
            const rules = []
            if (this.isProductFieldMandatory('PICK_UP_TIME') && !this.disableRequiredRule) {
                rules.push(this.requiredRule('transfers.pickup_time', 'PICK_UP_TIME'))
            }
            return rules
        }

        get hotelRules() {
            const rules = []
            if (this.isProductFieldMandatory('PICK_UP_HOTEL') && !this.disableRequiredRule) {
                rules.push(this.requiredRule('select_hotel', 'PICK_UP_HOTEL'))
            }
            return rules
        }

        get placeRules() {
            const rules = []
            if (this.isProductFieldMandatory('PICK_UP_PLACE') && !this.disableRequiredRule) {
                rules.push(this.requiredRule('pickup_location', 'PICK_UP_PLACE'))
            }
            return rules
        }
    }

    export default ActivityBookingForm
</script>
